import { isString, set } from 'lodash-es'

import { NetLerp } from '../NetLerp'

export class ClientEntity {
  constructor(world, data) {
    this.world = world
    this.data = data
    this.hots = new Set()
  }

  initialize() {
    this.init?.()
  }

  get id() {
    return this.data.id
  }

  get chunkId() {
    return this.data.chunkId
  }

  set(a1, a2) {
    const values = isString(a1) ? { [a1]: a2 } : a1
    const changes = {}
    for (const path in values) {
      set(this.data, path, values[path])
      set(changes, path, values[path])
    }
    this.onChange?.(changes)
  }

  setHot(fn, enabled) {
    if (enabled) {
      this.hots.add(fn)
      this.world.setHot(fn, true)
      return
    }
    this.hots.delete(fn)
    this.world.setHot(fn, false)
  }

  networkMove(x, y) {
    if (!this._lerp) {
      this._lerp = new NetLerp()
      this._lerp.push(x, y)
      this.setHot(this.updateLerp, true)
    }
    this._lerp.push(x, y)
  }

  updateLerp = () => {
    if (!this._lerp) return
    const pos = this._lerp.getPosition()
    if (!pos) return
    this.set({ 'position.x': pos.x, 'position.y': pos.y })
  }

  teleport(x, y) {
    if (this._lerp) {
      this._lerp = null
      this.setHot(this.updateLerp, false)
    }
    this.set({ 'position.x': x, 'position.y': y })
    if (this.world.playerId === this.id) {
      this.world.setCameraTarget(x, y + 1, 0)
    }
  }

  getPosition() {
    return this.data.position
  }

  getBase() {
    const pos = this.data.position
    return { x: pos.x, y: pos.y + (pos.yBase ?? 0) }
  }

  getCenter() {
    const pos = this.data.position
    return { x: pos.x, y: pos.y + (pos.yCenter ?? 0) }
  }

  destroy() {
    for (const fn of this.hots) {
      this.world.setHot(fn, false)
    }
    this.hots.clear()
  }
}
